const data = [
	{
		NPTEL: `AICTE approved 12 week course on “ Introduction of Internet of Thing”`,
	},
	{
		NPTEL: `AICTE approved 8 week course on “Accreditation and Outcome based Education”`,
	},
	{
		NPTEL: `AICTE approved 8 week course on “Cloud Computing”`,
	},
	{
		NPTEL: `AICTE approved 12-week course on” NBA Accreditation and Teaching Learning in 
		Engineering”`,
	},
	{
		NPTEL: `AICTE approved 8 week course on “Data Science for Engineers”`,
	},
	{
		NPTEL: `AICTE approved 8 week course on “Block Chain Technology”`,
	},
	{
		NPTEL: `AICTE approved 8 week course on “Research Methodology”`,
	},
	{
		NPTEL: `AICTE approved 8 week course on “Teaching Methodology”`,
	},
	{
		NPTEL: `AICTE approved 8 week course on “Machine Learning”
		`,
	},
	{
		NPTEL: `AICTE approved 12 week course on “ Industry 4.0 & IOT"`,
	},
	{
		NPTEL: `AICTE approved 8 week course on ” Data Mining”
		`,
	},
];

export default data;
